import type { PropsWithChildren, ReactElement } from 'react';
import { createContext, useContext } from 'react';

interface PreviewModalContextType {
  onClose: () => void;
}

const PreviewModalContext = createContext<PreviewModalContextType | null>(null);

export function usePreviewModalContext(): PreviewModalContextType {
  const context = useContext(PreviewModalContext);

  if (!context) {
    throw new Error('usePreviewModalContext must be used as a PreviewModalContext');
  }

  return context;
}

export function PreviewModalContextProvider({
  children,
  ...value
}: PropsWithChildren<PreviewModalContextType>): ReactElement {
  return <PreviewModalContext.Provider value={value}>{children}</PreviewModalContext.Provider>;
}
